import React from "react";
import Card from "../../common/Card";
import { Certificate, GraduationCap } from "@phosphor-icons/react";

const Certifications = () => {
    return <Card title={"الشهادات"} icon={<Certificate size={32} />}></Card>;
};

export default Certifications;
